// extracted by mini-css-extract-plugin
export default {"products":"zB-z","card":"AB-z","oosMessaging":"BB-z"};